import { BCMSRecord, Workflow, useGlobalController, useParams } from "@bcm-dev/bcms-vite";
import PayeeDetailsPage from "components/pages/PayeeDetailsPage";
import WirePayeesPage from "components/pages/WirePayeesPage";
import Classes, { Payee } from "model";
import React from "react";

// Steps of the workflow
const steps = [ WirePayeesPage, PayeeDetailsPage ];

/**
 * @function WireAddPayeeWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "Wire Payee" page.
 */
export default function WireAddPayeeWorkflow(props) {
    const controller = useGlobalController();
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);
    // Return the default workflow state
    return { 
        data: {
            selectedPayeeID: undefined,
            payees: Payee.initAll()
        }
    };
};